module.exports = __webpack_public_path__ + "static/img/jp2.38b08b5a.png";